import { render, staticRenderFns } from "./HorseMenuPhotoMobile.vue?vue&type=template&id=558cda24&"
import script from "./HorseMenuPhotoMobile.vue?vue&type=script&lang=js&"
export * from "./HorseMenuPhotoMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports